import { defineComponent as B, inject as V, computed as m, createElementBlock as s, openBlock as t, mergeProps as P, renderSlot as N, createCommentVNode as $, createElementVNode as e, createVNode as H, unref as L, toDisplayString as k, ref as S, onMounted as D, onUnmounted as F, normalizeClass as M, Transition as O, withCtx as z, Fragment as Z, renderList as _, normalizeStyle as j, createTextVNode as C, createBlock as I } from "vue";
const J = ["width", "height", "fill", "transform"], K = { key: 0 }, Y = /* @__PURE__ */ e("path", { d: "M222.14,105.85l-80-80a20,20,0,0,0-28.28,0l-80,80A19.86,19.86,0,0,0,28,120v96a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V164h24v52a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V120A19.86,19.86,0,0,0,222.14,105.85ZM204,204H164V152a12,12,0,0,0-12-12H104a12,12,0,0,0-12,12v52H52V121.65l76-76,76,76Z" }, null, -1), Q = [
  Y
], X = { key: 1 }, aa = /* @__PURE__ */ e("path", {
  d: "M216,120v96H152V152H104v64H40V120a8,8,0,0,1,2.34-5.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,216,120Z",
  opacity: "0.2"
}, null, -1), ea = /* @__PURE__ */ e("path", { d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z" }, null, -1), ta = [
  aa,
  ea
], sa = { key: 2 }, oa = /* @__PURE__ */ e("path", { d: "M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z" }, null, -1), na = [
  oa
], la = { key: 3 }, ra = /* @__PURE__ */ e("path", { d: "M217.9,110.1l-80-80a14,14,0,0,0-19.8,0l-80,80A13.92,13.92,0,0,0,34,120v96a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V158h36v58a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V120A13.92,13.92,0,0,0,217.9,110.1ZM210,210H158V152a6,6,0,0,0-6-6H104a6,6,0,0,0-6,6v58H46V120a2,2,0,0,1,.58-1.42l80-80a2,2,0,0,1,2.84,0l80,80A2,2,0,0,1,210,120Z" }, null, -1), ia = [
  ra
], ua = { key: 4 }, ca = /* @__PURE__ */ e("path", { d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z" }, null, -1), da = [
  ca
], ha = { key: 5 }, va = /* @__PURE__ */ e("path", { d: "M216.49,111.51l-80-80a12,12,0,0,0-17,0l-80,80A12,12,0,0,0,36,120v96a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V156h40v60a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V120A12,12,0,0,0,216.49,111.51ZM212,212H156V152a4,4,0,0,0-4-4H104a4,4,0,0,0-4,4v60H44V120a4,4,0,0,1,1.17-2.83l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,212,120Z" }, null, -1), pa = [
  va
], ma = {
  name: "PhHouse"
}, q = /* @__PURE__ */ B({
  ...ma,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(a) {
    const u = a, i = V("weight", "regular"), v = V("size", "1em"), h = V("color", "currentColor"), p = V("mirrored", !1), c = m(() => u.weight ?? i), g = m(() => u.size ?? v), f = m(() => u.color ?? h), y = m(() => u.mirrored !== void 0 ? u.mirrored ? "scale(-1, 1)" : void 0 : p ? "scale(-1, 1)" : void 0);
    return (l, d) => (t(), s("svg", P({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: g.value,
      height: g.value,
      fill: f.value,
      transform: y.value
    }, l.$attrs), [
      N(l.$slots, "default"),
      c.value === "bold" ? (t(), s("g", K, Q)) : c.value === "duotone" ? (t(), s("g", X, ta)) : c.value === "fill" ? (t(), s("g", sa, na)) : c.value === "light" ? (t(), s("g", la, ia)) : c.value === "regular" ? (t(), s("g", ua, da)) : c.value === "thin" ? (t(), s("g", ha, pa)) : $("", !0)
    ], 16, J));
  }
}), ga = ["width", "height", "fill", "transform"], fa = { key: 0 }, ya = /* @__PURE__ */ e("path", { d: "M124,216a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V40A12,12,0,0,1,48,28h64a12,12,0,0,1,0,24H60V204h52A12,12,0,0,1,124,216Zm108.49-96.49-40-40a12,12,0,0,0-17,17L195,116H112a12,12,0,0,0,0,24h83l-19.52,19.51a12,12,0,0,0,17,17l40-40A12,12,0,0,0,232.49,119.51Z" }, null, -1), ka = [
  ya
], ba = { key: 1 }, wa = /* @__PURE__ */ e("path", {
  d: "M224,56V200a16,16,0,0,1-16,16H48V40H208A16,16,0,0,1,224,56Z",
  opacity: "0.2"
}, null, -1), $a = /* @__PURE__ */ e("path", { d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z" }, null, -1), Aa = [
  wa,
  $a
], Va = { key: 2 }, Ha = /* @__PURE__ */ e("path", { d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40A8,8,0,0,0,176,88v32H112a8,8,0,0,0,0,16h64v32a8,8,0,0,0,13.66,5.66l40-40A8,8,0,0,0,229.66,122.34Z" }, null, -1), La = [
  Ha
], Sa = { key: 3 }, Ma = /* @__PURE__ */ e("path", { d: "M118,216a6,6,0,0,1-6,6H48a6,6,0,0,1-6-6V40a6,6,0,0,1,6-6h64a6,6,0,0,1,0,12H54V210h58A6,6,0,0,1,118,216Zm110.24-92.24-40-40a6,6,0,0,0-8.48,8.48L209.51,122H112a6,6,0,0,0,0,12h97.51l-29.75,29.76a6,6,0,1,0,8.48,8.48l40-40A6,6,0,0,0,228.24,123.76Z" }, null, -1), Ba = [
  Ma
], Ca = { key: 4 }, Za = /* @__PURE__ */ e("path", { d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z" }, null, -1), _a = [
  Za
], xa = { key: 5 }, Ea = /* @__PURE__ */ e("path", { d: "M116,216a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h64a4,4,0,0,1,0,8H52V212h60A4,4,0,0,1,116,216Zm110.83-90.83-40-40a4,4,0,0,0-5.66,5.66L214.34,124H112a4,4,0,0,0,0,8H214.34l-33.17,33.17a4,4,0,0,0,5.66,5.66l40-40A4,4,0,0,0,226.83,125.17Z" }, null, -1), Ua = [
  Ea
], Ia = {
  name: "PhSignOut"
}, W = /* @__PURE__ */ B({
  ...Ia,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(a) {
    const u = a, i = V("weight", "regular"), v = V("size", "1em"), h = V("color", "currentColor"), p = V("mirrored", !1), c = m(() => u.weight ?? i), g = m(() => u.size ?? v), f = m(() => u.color ?? h), y = m(() => u.mirrored !== void 0 ? u.mirrored ? "scale(-1, 1)" : void 0 : p ? "scale(-1, 1)" : void 0);
    return (l, d) => (t(), s("svg", P({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: g.value,
      height: g.value,
      fill: f.value,
      transform: y.value
    }, l.$attrs), [
      N(l.$slots, "default"),
      c.value === "bold" ? (t(), s("g", fa, ka)) : c.value === "duotone" ? (t(), s("g", ba, Aa)) : c.value === "fill" ? (t(), s("g", Va, La)) : c.value === "light" ? (t(), s("g", Sa, Ba)) : c.value === "regular" ? (t(), s("g", Ca, _a)) : c.value === "thin" ? (t(), s("g", xa, Ua)) : $("", !0)
    ], 16, ga));
  }
}), Pa = ["width", "height", "fill", "transform"], Na = { key: 0 }, Da = /* @__PURE__ */ e("path", { d: "M199,125.31l-49.88-18.39L130.69,57a19.92,19.92,0,0,0-37.38,0L74.92,106.92,25,125.31a19.92,19.92,0,0,0,0,37.38l49.88,18.39L93.31,231a19.92,19.92,0,0,0,37.38,0l18.39-49.88L199,162.69a19.92,19.92,0,0,0,0-37.38Zm-63.38,35.16a12,12,0,0,0-7.11,7.11L112,212.28l-16.47-44.7a12,12,0,0,0-7.11-7.11L43.72,144l44.7-16.47a12,12,0,0,0,7.11-7.11L112,75.72l16.47,44.7a12,12,0,0,0,7.11,7.11L180.28,144ZM140,40a12,12,0,0,1,12-12h12V16a12,12,0,0,1,24,0V28h12a12,12,0,0,1,0,24H188V64a12,12,0,0,1-24,0V52H152A12,12,0,0,1,140,40ZM252,88a12,12,0,0,1-12,12h-4v4a12,12,0,0,1-24,0v-4h-4a12,12,0,0,1,0-24h4V72a12,12,0,0,1,24,0v4h4A12,12,0,0,1,252,88Z" }, null, -1), Oa = [
  Da
], za = { key: 1 }, Ra = /* @__PURE__ */ e("path", {
  d: "M194.82,151.43l-55.09,20.3-20.3,55.09a7.92,7.92,0,0,1-14.86,0l-20.3-55.09-55.09-20.3a7.92,7.92,0,0,1,0-14.86l55.09-20.3,20.3-55.09a7.92,7.92,0,0,1,14.86,0l20.3,55.09,55.09,20.3A7.92,7.92,0,0,1,194.82,151.43Z",
  opacity: "0.2"
}, null, -1), Ta = /* @__PURE__ */ e("path", { d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z" }, null, -1), Fa = [
  Ra,
  Ta
], ja = { key: 2 }, qa = /* @__PURE__ */ e("path", { d: "M208,144a15.78,15.78,0,0,1-10.42,14.94L146,178l-19,51.62a15.92,15.92,0,0,1-29.88,0L78,178l-51.62-19a15.92,15.92,0,0,1,0-29.88L78,110l19-51.62a15.92,15.92,0,0,1,29.88,0L146,110l51.62,19A15.78,15.78,0,0,1,208,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z" }, null, -1), Wa = [
  qa
], Ga = { key: 3 }, Ja = /* @__PURE__ */ e("path", { d: "M196.89,130.94,144.4,111.6,125.06,59.11a13.92,13.92,0,0,0-26.12,0L79.6,111.6,27.11,130.94a13.92,13.92,0,0,0,0,26.12L79.6,176.4l19.34,52.49a13.92,13.92,0,0,0,26.12,0L144.4,176.4l52.49-19.34a13.92,13.92,0,0,0,0-26.12Zm-4.15,14.86-55.08,20.3a6,6,0,0,0-3.56,3.56l-20.3,55.08a1.92,1.92,0,0,1-3.6,0L89.9,169.66a6,6,0,0,0-3.56-3.56L31.26,145.8a1.92,1.92,0,0,1,0-3.6l55.08-20.3a6,6,0,0,0,3.56-3.56l20.3-55.08a1.92,1.92,0,0,1,3.6,0l20.3,55.08a6,6,0,0,0,3.56,3.56l55.08,20.3a1.92,1.92,0,0,1,0,3.6ZM146,40a6,6,0,0,1,6-6h18V16a6,6,0,0,1,12,0V34h18a6,6,0,0,1,0,12H182V64a6,6,0,0,1-12,0V46H152A6,6,0,0,1,146,40ZM246,88a6,6,0,0,1-6,6H230v10a6,6,0,0,1-12,0V94H208a6,6,0,0,1,0-12h10V72a6,6,0,0,1,12,0V82h10A6,6,0,0,1,246,88Z" }, null, -1), Ka = [
  Ja
], Ya = { key: 4 }, Qa = /* @__PURE__ */ e("path", { d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z" }, null, -1), Xa = [
  Qa
], ae = { key: 5 }, ee = /* @__PURE__ */ e("path", { d: "M196.2,132.81l-53.36-19.65L123.19,59.8a11.93,11.93,0,0,0-22.38,0L81.16,113.16,27.8,132.81a11.93,11.93,0,0,0,0,22.38l53.36,19.65,19.65,53.36a11.93,11.93,0,0,0,22.38,0l19.65-53.36,53.36-19.65a11.93,11.93,0,0,0,0-22.38Zm-2.77,14.87L138.35,168a4,4,0,0,0-2.37,2.37l-20.3,55.08a3.92,3.92,0,0,1-7.36,0L88,170.35A4,4,0,0,0,85.65,168l-55.08-20.3a3.92,3.92,0,0,1,0-7.36L85.65,120A4,4,0,0,0,88,117.65l20.3-55.08a3.92,3.92,0,0,1,7.36,0L136,117.65a4,4,0,0,0,2.37,2.37l55.08,20.3a3.92,3.92,0,0,1,0,7.36ZM148,40a4,4,0,0,1,4-4h20V16a4,4,0,0,1,8,0V36h20a4,4,0,0,1,0,8H180V64a4,4,0,0,1-8,0V44H152A4,4,0,0,1,148,40Zm96,48a4,4,0,0,1-4,4H228v12a4,4,0,0,1-8,0V92H208a4,4,0,0,1,0-8h12V72a4,4,0,0,1,8,0V84h12A4,4,0,0,1,244,88Z" }, null, -1), te = [
  ee
], se = {
  name: "PhSparkle"
}, x = /* @__PURE__ */ B({
  ...se,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(a) {
    const u = a, i = V("weight", "regular"), v = V("size", "1em"), h = V("color", "currentColor"), p = V("mirrored", !1), c = m(() => u.weight ?? i), g = m(() => u.size ?? v), f = m(() => u.color ?? h), y = m(() => u.mirrored !== void 0 ? u.mirrored ? "scale(-1, 1)" : void 0 : p ? "scale(-1, 1)" : void 0);
    return (l, d) => (t(), s("svg", P({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: g.value,
      height: g.value,
      fill: f.value,
      transform: y.value
    }, l.$attrs), [
      N(l.$slots, "default"),
      c.value === "bold" ? (t(), s("g", Na, Oa)) : c.value === "duotone" ? (t(), s("g", za, Fa)) : c.value === "fill" ? (t(), s("g", ja, Wa)) : c.value === "light" ? (t(), s("g", Ga, Ka)) : c.value === "regular" ? (t(), s("g", Ya, Xa)) : c.value === "thin" ? (t(), s("g", ae, te)) : $("", !0)
    ], 16, Pa));
  }
}), oe = { class: "ha-spark-balance" }, ne = { class: "ha-spark-value" }, le = /* @__PURE__ */ B({
  __name: "SparkBalance",
  props: {
    balance: {}
  },
  setup(a) {
    const u = a, i = m(() => u.balance.toLocaleString());
    return (v, h) => (t(), s("div", oe, [
      H(L(x), {
        class: "ha-spark-icon",
        weight: "fill"
      }),
      e("span", ne, k(i.value), 1)
    ]));
  }
}), E = (a, u) => {
  const i = a.__vccOpts || a;
  for (const [v, h] of u)
    i[v] = h;
  return i;
}, re = /* @__PURE__ */ E(le, [["__scopeId", "data-v-8fcfd089"]]), ie = ["aria-expanded"], ue = {
  key: 0,
  class: "ha-products-menu"
}, ce = { class: "ha-category-products" }, de = ["href"], he = { class: "ha-product-name" }, ve = {
  key: 0,
  class: "ha-product-description"
}, pe = /* @__PURE__ */ B({
  __name: "ProductsDropdown",
  props: {
    products: {},
    currentSlug: {}
  },
  setup(a) {
    const u = a, i = S(!1), v = S(null), h = {
      Build: { order: 1, color: "#d946ef" },
      // fuchsia-500
      Analyze: { order: 2, color: "#ec4899" },
      // pink-500
      Manage: { order: 3, color: "#a3e635" }
      // lime-400
    }, p = m(() => {
      const d = {};
      for (const r of u.products) {
        const o = r.category || "Other";
        d[o] || (d[o] = []), d[o].push(r);
      }
      return Object.entries(d).sort(([r], [o]) => {
        var b, A;
        const n = ((b = h[r]) == null ? void 0 : b.order) ?? 99, w = ((A = h[o]) == null ? void 0 : A.order) ?? 99;
        return n - w;
      });
    });
    function c(d) {
      var r;
      return ((r = h[d]) == null ? void 0 : r.color) || "#6b7280";
    }
    function g() {
      i.value = !i.value;
    }
    function f() {
      i.value = !1;
    }
    function y(d) {
      v.value && !v.value.contains(d.target) && f();
    }
    function l(d) {
      d.key === "Escape" && f();
    }
    return D(() => {
      document.addEventListener("click", y), document.addEventListener("keydown", l);
    }), F(() => {
      document.removeEventListener("click", y), document.removeEventListener("keydown", l);
    }), (d, r) => (t(), s("div", {
      class: "ha-products-dropdown",
      ref_key: "dropdownRef",
      ref: v
    }, [
      e("button", {
        onClick: g,
        class: "ha-products-trigger",
        "aria-expanded": i.value
      }, [
        r[1] || (r[1] = e("span", null, "Products", -1)),
        (t(), s("svg", {
          class: M(["ha-dropdown-chevron", { "ha-dropdown-chevron--open": i.value }]),
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [...r[0] || (r[0] = [
          e("path", { d: "M6 9l6 6 6-6" }, null, -1)
        ])], 2))
      ], 8, ie),
      H(O, { name: "ha-dropdown" }, {
        default: z(() => [
          i.value ? (t(), s("div", ue, [
            (t(!0), s(Z, null, _(p.value, ([o, n], w) => (t(), s("div", {
              key: o,
              class: M({ "ha-category-section--spaced": w > 0 })
            }, [
              e("h3", {
                class: "ha-category-header",
                style: j({ color: c(o) })
              }, k(o), 5),
              e("div", ce, [
                (t(!0), s(Z, null, _(n, (b) => (t(), s("a", {
                  key: b.slug,
                  href: b.url,
                  onClick: f,
                  class: M(["ha-product-item", { "ha-product-item--current": b.slug === a.currentSlug }])
                }, [
                  e("span", he, k(b.name), 1),
                  b.description ? (t(), s("span", ve, k(b.description), 1)) : $("", !0)
                ], 10, de))), 128))
              ])
            ], 2))), 128))
          ])) : $("", !0)
        ]),
        _: 1
      })
    ], 512));
  }
}), me = /* @__PURE__ */ E(pe, [["__scopeId", "data-v-1678d273"]]), ge = [
  {
    slug: "storyboard2rise",
    name: "Storyboard2Rise",
    icon: "",
    url: "https://storyboard2rise.happyalien.ai",
    status: "active",
    category: "Build",
    description: "Convert Word storyboards to Rise courses"
  },
  {
    slug: "media",
    name: "AI Media App",
    icon: "",
    url: "https://media.happyalien.ai",
    status: "active",
    category: "Build",
    description: "Generate images, audio, and video with AI"
  },
  {
    slug: "course-translator",
    name: "Course Translator",
    icon: "",
    url: "https://course-translator.happyalien.ai",
    status: "active",
    category: "Build",
    description: "Translate Captivate courses to any language"
  },
  {
    slug: "vidsabio",
    name: "VidSabio",
    icon: "",
    url: "https://vidsabio.happyalien.ai",
    status: "active",
    category: "Analyze",
    description: "Transform videos into structured courses"
  },
  {
    slug: "course-extractor",
    name: "Course Extractor",
    icon: "",
    url: "https://course-extractor.happyalien.ai",
    status: "active",
    category: "Analyze",
    description: "Extract any course — Storyline, Rise, Captivate, SCORM, HTML"
  },
  {
    slug: "echocast",
    name: "EchoCast",
    icon: "",
    url: "https://echocast.happyalien.ai",
    status: "active",
    category: "Manage",
    description: "Inject modals into eLearning courses"
  },
  {
    slug: "dashboard",
    name: "Sparks Dashboard",
    icon: "",
    url: "https://sparks.happyalien.ai",
    status: "active",
    category: "Manage",
    description: "Manage your account and sparks"
  }
], G = "https://api.happyalien.ai", R = "https://sparks.happyalien.ai", fe = ["aria-expanded"], ye = { class: "ha-user-avatar" }, ke = ["src", "alt"], be = {
  key: 1,
  class: "ha-user-avatar-initial"
}, we = {
  key: 0,
  class: "ha-user-dropdown"
}, $e = { class: "ha-user-info" }, Ae = { class: "ha-user-name" }, Ve = { class: "ha-user-email" }, He = ["href"], Le = ["href"], Se = /* @__PURE__ */ B({
  __name: "UserMenu",
  props: {
    user: {},
    dashboardUrl: { default: R },
    showBuySparks: { type: Boolean, default: !0 }
  },
  emits: ["logout"],
  setup(a, { emit: u }) {
    const i = a, v = u, h = S(!1), p = S(null), c = m(() => {
      var o, n;
      return ((o = i.user) == null ? void 0 : o.display_name) || ((n = i.user) == null ? void 0 : n.email) || "User";
    }), g = m(() => {
      var n, w;
      return (((n = i.user) == null ? void 0 : n.display_name) || ((w = i.user) == null ? void 0 : w.email) || "?").charAt(0).toUpperCase();
    });
    function f() {
      h.value = !h.value;
    }
    function y() {
      h.value = !1;
    }
    function l() {
      y(), v("logout");
    }
    function d(o) {
      p.value && !p.value.contains(o.target) && y();
    }
    function r(o) {
      o.key === "Escape" && y();
    }
    return D(() => {
      document.addEventListener("click", d), document.addEventListener("keydown", r);
    }), F(() => {
      document.removeEventListener("click", d), document.removeEventListener("keydown", r);
    }), (o, n) => {
      var w;
      return t(), s("div", {
        class: "ha-user-menu",
        ref_key: "menuRef",
        ref: p
      }, [
        e("button", {
          onClick: f,
          class: "ha-user-trigger",
          "aria-expanded": h.value
        }, [
          e("div", ye, [
            (w = a.user) != null && w.avatar_url ? (t(), s("img", {
              key: 0,
              src: a.user.avatar_url,
              alt: c.value,
              class: "ha-user-avatar-img"
            }, null, 8, ke)) : (t(), s("span", be, k(g.value), 1))
          ]),
          (t(), s("svg", {
            class: M(["ha-user-chevron", { "ha-user-chevron--open": h.value }]),
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [...n[0] || (n[0] = [
            e("path", { d: "M6 9l6 6 6-6" }, null, -1)
          ])], 2))
        ], 8, fe),
        H(O, { name: "ha-dropdown" }, {
          default: z(() => {
            var b;
            return [
              h.value ? (t(), s("div", we, [
                e("div", $e, [
                  e("div", Ae, k(c.value), 1),
                  e("div", Ve, k((b = a.user) == null ? void 0 : b.email), 1)
                ]),
                n[4] || (n[4] = e("div", { class: "ha-user-divider" }, null, -1)),
                e("a", {
                  href: a.dashboardUrl,
                  class: "ha-user-item"
                }, [
                  H(L(q), { class: "ha-user-item-icon" }),
                  n[1] || (n[1] = C(" Dashboard ", -1))
                ], 8, He),
                a.showBuySparks ? (t(), s("a", {
                  key: 0,
                  href: `${a.dashboardUrl}/buy`,
                  class: "ha-user-item"
                }, [
                  H(L(x), {
                    class: "ha-user-item-icon",
                    weight: "fill"
                  }),
                  n[2] || (n[2] = C(" Buy Sparks ", -1))
                ], 8, Le)) : $("", !0),
                n[5] || (n[5] = e("div", { class: "ha-user-divider" }, null, -1)),
                e("button", {
                  onClick: l,
                  class: "ha-user-item ha-user-item--logout"
                }, [
                  H(L(W), { class: "ha-user-item-icon" }),
                  n[3] || (n[3] = C(" Sign out ", -1))
                ])
              ])) : $("", !0)
            ];
          }),
          _: 1
        })
      ], 512);
    };
  }
}), Me = /* @__PURE__ */ E(Se, [["__scopeId", "data-v-65e616f4"]]), Be = {
  key: 0,
  class: "ha-mobile-menu"
}, Ce = { class: "ha-mobile-menu-content" }, Ze = {
  key: 0,
  class: "ha-mobile-nav"
}, _e = ["href", "onClick"], xe = {
  key: 0,
  class: "ha-mobile-nav-icon"
}, Ee = {
  key: 1,
  class: "ha-mobile-user-section"
}, Ue = { class: "ha-mobile-user-info" }, Ie = { class: "ha-mobile-user-avatar" }, Pe = ["src", "alt"], Ne = { key: 1 }, De = { class: "ha-mobile-user-name" }, Oe = { class: "ha-mobile-user-email" }, ze = {
  key: 0,
  class: "ha-mobile-spark-balance"
}, Re = { class: "ha-mobile-spark-value" }, Te = { class: "ha-mobile-products-section" }, Fe = ["href"], je = { class: "ha-mobile-product-name" }, qe = {
  key: 0,
  class: "ha-mobile-product-description"
}, We = { class: "ha-mobile-actions" }, Ge = ["href"], Je = ["href"], Ke = ["href"], Ye = /* @__PURE__ */ B({
  __name: "MobileMenu",
  props: {
    isOpen: { type: Boolean },
    navItems: {},
    products: {},
    currentSlug: {},
    isAuthenticated: { type: Boolean },
    user: {},
    sparkBalance: { default: 0 },
    dashboardUrl: { default: R },
    showSparkBalance: { type: Boolean, default: !0 },
    showBuySparks: { type: Boolean, default: !0 }
  },
  emits: ["close", "logout"],
  setup(a, { emit: u }) {
    const i = a, v = u, h = m(() => {
      var r, o;
      return ((r = i.user) == null ? void 0 : r.display_name) || ((o = i.user) == null ? void 0 : o.email) || "User";
    }), p = m(() => {
      var o, n;
      return (((o = i.user) == null ? void 0 : o.display_name) || ((n = i.user) == null ? void 0 : n.email) || "?").charAt(0).toUpperCase();
    }), c = m(() => i.navItems.filter((r) => !(r.requiresAuth && !i.isAuthenticated))), g = {
      Build: { order: 1, color: "#d946ef" },
      // fuchsia-500
      Analyze: { order: 2, color: "#ec4899" },
      // pink-500
      Manage: { order: 3, color: "#a3e635" }
      // lime-400
    }, f = m(() => {
      const r = {};
      for (const o of i.products) {
        const n = o.category || "Other";
        r[n] || (r[n] = []), r[n].push(o);
      }
      return Object.entries(r).sort(([o], [n]) => {
        var A, U;
        const w = ((A = g[o]) == null ? void 0 : A.order) ?? 99, b = ((U = g[n]) == null ? void 0 : U.order) ?? 99;
        return w - b;
      });
    });
    function y(r) {
      var o;
      return ((o = g[r]) == null ? void 0 : o.color) || "#6b7280";
    }
    function l(r, o) {
      r.action && (o.preventDefault(), r.action()), v("close");
    }
    function d() {
      v("logout"), v("close");
    }
    return (r, o) => (t(), I(O, { name: "ha-mobile-menu" }, {
      default: z(() => [
        a.isOpen ? (t(), s("div", Be, [
          e("div", Ce, [
            a.navItems.length > 0 ? (t(), s("nav", Ze, [
              (t(!0), s(Z, null, _(c.value, (n) => (t(), s("a", {
                key: n.label,
                href: n.href,
                onClick: (w) => l(n, w),
                class: M(["ha-mobile-nav-item", { "ha-mobile-nav-item--active": n.active }])
              }, [
                n.icon ? (t(), s("span", xe, k(n.icon), 1)) : $("", !0),
                C(" " + k(n.label), 1)
              ], 10, _e))), 128))
            ])) : $("", !0),
            a.isAuthenticated && a.user ? (t(), s("div", Ee, [
              e("div", Ue, [
                e("div", Ie, [
                  a.user.avatar_url ? (t(), s("img", {
                    key: 0,
                    src: a.user.avatar_url,
                    alt: h.value
                  }, null, 8, Pe)) : (t(), s("span", Ne, k(p.value), 1))
                ]),
                e("div", null, [
                  e("div", De, k(h.value), 1),
                  e("div", Oe, k(a.user.email), 1)
                ])
              ]),
              a.showSparkBalance ? (t(), s("div", ze, [
                o[1] || (o[1] = e("span", null, "Balance:", -1)),
                e("span", Re, k(a.sparkBalance.toLocaleString()), 1),
                H(L(x), {
                  class: "ha-mobile-spark-icon",
                  weight: "fill"
                })
              ])) : $("", !0)
            ])) : $("", !0),
            e("div", Te, [
              o[2] || (o[2] = e("div", { class: "ha-mobile-section-title" }, "Products", -1)),
              (t(!0), s(Z, null, _(f.value, ([n, w], b) => (t(), s("div", {
                key: n,
                class: M({ "ha-mobile-category--spaced": b > 0 })
              }, [
                e("div", {
                  class: "ha-mobile-category-header",
                  style: j({ color: y(n) })
                }, k(n), 5),
                (t(!0), s(Z, null, _(w, (A) => (t(), s("a", {
                  key: A.slug,
                  href: A.url,
                  onClick: o[0] || (o[0] = (U) => v("close")),
                  class: M(["ha-mobile-product-item", { "ha-mobile-product-item--current": A.slug === a.currentSlug }])
                }, [
                  e("span", je, k(A.name), 1),
                  A.description ? (t(), s("span", qe, k(A.description), 1)) : $("", !0)
                ], 10, Fe))), 128))
              ], 2))), 128))
            ]),
            e("div", We, [
              a.isAuthenticated ? (t(), s(Z, { key: 0 }, [
                e("a", {
                  href: a.dashboardUrl,
                  class: "ha-mobile-action-item"
                }, [
                  H(L(q), { class: "ha-mobile-action-icon" }),
                  o[3] || (o[3] = C(" Dashboard ", -1))
                ], 8, Ge),
                a.showBuySparks ? (t(), s("a", {
                  key: 0,
                  href: `${a.dashboardUrl}/buy`,
                  class: "ha-mobile-action-item"
                }, [
                  H(L(x), {
                    class: "ha-mobile-action-icon",
                    weight: "fill"
                  }),
                  o[4] || (o[4] = C(" Buy Sparks ", -1))
                ], 8, Je)) : $("", !0),
                e("button", {
                  onClick: d,
                  class: "ha-mobile-action-item ha-mobile-action-item--logout"
                }, [
                  H(L(W), { class: "ha-mobile-action-icon" }),
                  o[5] || (o[5] = C(" Sign out ", -1))
                ])
              ], 64)) : (t(), s("a", {
                key: 1,
                href: `${a.dashboardUrl}/login`,
                class: "ha-mobile-signin-btn"
              }, " Sign In ", 8, Ke))
            ])
          ])
        ])) : $("", !0)
      ]),
      _: 1
    }));
  }
}), Qe = /* @__PURE__ */ E(Ye, [["__scopeId", "data-v-7917d8a9"]]), T = "ha_products", Xe = 24 * 60 * 60 * 1e3;
function a0(a = G) {
  const u = S(h()), i = S(!1), v = S(null);
  function h() {
    const l = p();
    return (l == null ? void 0 : l.data) || [...ge];
  }
  function p() {
    if (typeof localStorage > "u") return null;
    try {
      const l = localStorage.getItem(T);
      return l ? JSON.parse(l) : null;
    } catch {
      return null;
    }
  }
  function c(l) {
    if (!(typeof localStorage > "u"))
      try {
        const d = {
          data: l,
          timestamp: Date.now()
        };
        localStorage.setItem(T, JSON.stringify(d));
      } catch {
      }
  }
  async function g() {
    const l = await fetch(`${a}/products/nav`);
    if (!l.ok)
      throw new Error(`Failed to fetch products: ${l.status}`);
    const d = await l.json();
    if (d.success && Array.isArray(d.data))
      return d.data;
    throw new Error("Invalid API response");
  }
  async function f() {
    i.value = !0, v.value = null;
    try {
      const l = await g();
      l.length > 0 && (u.value = l, c(l));
    } catch (l) {
      console.warn("[HappyAlien Nav] Failed to refresh products, using cached data:", l), v.value = l instanceof Error ? l.message : "Failed to load products";
    } finally {
      i.value = !1;
    }
  }
  async function y() {
    return f();
  }
  return D(() => {
    const l = p();
    (!l || Date.now() - l.timestamp > Xe) && f();
  }), {
    products: u,
    loading: i,
    error: v,
    loadProducts: f,
    refreshProducts: y
  };
}
const e0 = { class: "ha-nav-container" }, t0 = ["src"], s0 = { class: "ha-nav-brand-text" }, o0 = { class: "ha-nav-product-name" }, n0 = { class: "ha-nav-center" }, l0 = { class: "ha-nav-actions" }, r0 = ["href"], i0 = ["aria-expanded"], u0 = {
  key: 0,
  class: "ha-nav-mobile-icon"
}, c0 = {
  key: 1,
  class: "ha-nav-mobile-icon"
}, h0 = /* @__PURE__ */ B({
  __name: "HappyAlienNav",
  props: {
    productName: {},
    productSlug: {},
    navItems: { default: () => [] },
    position: { default: "fixed" },
    logoSrc: { default: "/logo.png" },
    apiUrl: { default: G },
    dashboardUrl: { default: R },
    isAuthenticated: { type: Boolean, default: !1 },
    user: { default: null },
    sparkBalance: { default: 0 },
    showSparkBalance: { type: Boolean, default: !0 },
    showBuySparks: { type: Boolean, default: !0 }
  },
  emits: ["logout", "brand-click"],
  setup(a, { emit: u }) {
    const i = a, v = u, { products: h } = a0(i.apiUrl), p = S(!1), c = S(!1), g = m(() => typeof window < "u" ? window.location.href : "/");
    function f() {
      v("logout");
    }
    function y() {
      c.value = !0;
    }
    function l(d) {
      v("brand-click");
    }
    return (d, r) => (t(), s("header", {
      class: M(["ha-nav", [
        `ha-nav--${a.position}`,
        { "ha-nav--mobile-open": p.value }
      ]])
    }, [
      e("div", e0, [
        e("a", {
          href: "/",
          class: "ha-nav-brand",
          onClick: l
        }, [
          e("img", {
            src: a.logoSrc,
            alt: "Happy Alien",
            class: "ha-nav-logo",
            onError: y
          }, null, 40, t0),
          e("div", s0, [
            r[2] || (r[2] = e("span", { class: "ha-nav-brand-name" }, "Happy Alien", -1)),
            e("span", o0, k(a.productName), 1)
          ])
        ]),
        e("div", n0, [
          H(me, {
            products: L(h),
            "current-slug": a.productSlug,
            class: "ha-nav-products"
          }, null, 8, ["products", "current-slug"])
        ]),
        e("div", l0, [
          a.isAuthenticated && a.showSparkBalance ? (t(), I(re, {
            key: 0,
            balance: a.sparkBalance,
            class: "ha-nav-sparks"
          }, null, 8, ["balance"])) : $("", !0),
          a.isAuthenticated ? (t(), I(Me, {
            key: 1,
            user: a.user,
            "dashboard-url": a.dashboardUrl,
            "show-buy-sparks": a.showBuySparks,
            onLogout: f,
            class: "ha-nav-user"
          }, null, 8, ["user", "dashboard-url", "show-buy-sparks"])) : (t(), s("a", {
            key: 2,
            href: `${a.dashboardUrl}/login?redirect=${encodeURIComponent(g.value)}`,
            class: "ha-nav-signin"
          }, " Sign In ", 8, r0)),
          e("button", {
            onClick: r[0] || (r[0] = (o) => p.value = !p.value),
            class: "ha-nav-mobile-toggle",
            "aria-expanded": p.value,
            "aria-label": "Toggle menu"
          }, [
            p.value ? (t(), s("span", c0, "✕")) : (t(), s("span", u0, "☰"))
          ], 8, i0)
        ])
      ]),
      H(Qe, {
        "is-open": p.value,
        "nav-items": a.navItems,
        products: L(h),
        "current-slug": a.productSlug,
        "is-authenticated": a.isAuthenticated,
        user: a.user,
        "spark-balance": a.sparkBalance,
        "show-spark-balance": a.showSparkBalance,
        "show-buy-sparks": a.showBuySparks,
        "dashboard-url": a.dashboardUrl,
        onClose: r[1] || (r[1] = (o) => p.value = !1),
        onLogout: f
      }, null, 8, ["is-open", "nav-items", "products", "current-slug", "is-authenticated", "user", "spark-balance", "show-spark-balance", "show-buy-sparks", "dashboard-url"])
    ], 2));
  }
});
export {
  G as DEFAULT_API_URL,
  R as DEFAULT_DASHBOARD_URL,
  ge as DEFAULT_PRODUCTS,
  h0 as HappyAlienNav,
  Qe as MobileMenu,
  me as ProductsDropdown,
  re as SparkBalance,
  Me as UserMenu,
  a0 as useProducts
};
